import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ImmersiveMode } from '../plugins/immersive-mode';

/**
 * Hides the Android system bars whenever any element enters fullscreen, so a
 * fullscreen video's controls are not overlapped by them (GT-1390). Listens at
 * the document level so it works regardless of how the video is embedded
 * (plain iframe or Vimeo Player API). Android only.
 */
@Injectable({ providedIn: 'root' })
export class ImmersiveVideoService {
  private started = false;

  start(): void {
    if (this.started || Capacitor.getPlatform() !== 'android') {
      return;
    }
    this.started = true;

    const onFullscreenChange = () => {
      const inFullscreen = !!(document.fullscreenElement || (document as any).webkitFullscreenElement);
      const request = inFullscreen ? ImmersiveMode.enable() : ImmersiveMode.disable();
      request.catch(() => { });
    };

    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', onFullscreenChange);
  }
}
